import styled, { css } from 'styled-components';

import { COLOR_ITEM_SIZE, DROPDOWN_WIDTH } from './constants';
import { IStyledColor, IStyledEventDropdown } from './types';

export const StyledEventDropdown = styled.div<IStyledEventDropdown>`
  position: fixed;
  z-index: 2;
  width: ${DROPDOWN_WIDTH}px;
  border-radius: 5px;
  background-color: #ffffff; // TODO: set from theme
  padding: 16px; // TODO: set from theme
  ${({ top, left, bottom, right, open }) => css`
    top: ${top}px;
    bottom: ${bottom}px;
    left: ${left}px;
    right: ${right}px;
    display: ${open ? 'block' : 'none'};
  `}
`;

export const StyledEventHeader = styled.div`
  margin: 0 -16px;
`;

export const ColorItem = styled.button<IStyledColor>`
  cursor: pointer;
  border: none;
  outline: none;
  width: ${COLOR_ITEM_SIZE}px;
  height: ${COLOR_ITEM_SIZE}px;
  border-radius: 50%;
  color: #ffffff;
  ${({ color }) => `background-color: ${color}`}
`;
